import React from 'react';
import { useIntegratedForm } from '../use-integrated-form';
import { FormButtonBase, FormButtonProps } from './form-button';

export function FormSaveButton(props: FormButtonProps): React.ReactElement {
    const integratedForm = useIntegratedForm();
    const buttonPropsMemo: FormButtonProps = React.useMemo(() => {
        return {
            variant: 'solid',
            children: 'Save',
            ...integratedForm.getSaveButtonProps(),
            onClick: integratedForm.onSubmit,
            ...props,
        };
    }, [props, integratedForm]);

    return <FormButtonBase data-testid="form-save" {...buttonPropsMemo} />;
}
